import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=6ae2c976"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=6ae2c976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports